<template>
  <div>
    <van-popup v-model="isVisible" position="center" :overlay="true" :close-on-click-overlay="true" round
      @close="handleClose">
      <div class="b-popup">
        <slot></slot>
        <div class="close" @click="close">
          <img src="@/assets/image/icon/tcclose.png" alt="关闭" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'BclosePopup',

  data() {
    return {
      isVisible: false
    };
  },

  mounted() {

  },

  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.$emit('close');
    },
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.b-popup {
  width: 16.5rem;
  background: linear-gradient(180deg, #fff3d4 0%, #ffffff 20%);
  border-radius: .5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1.15rem;
  position: relative;

  .title {
    font-weight: 700;
    font-size: .8rem;
  }

  .cdkbox {
    width: 11.5rem;
    height: 2rem;
    background: #ffeab3;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    justify-content: space-between;
    margin: .5rem 0;
    margin-top: 1rem;

    .text {
      font-size: .7rem;
      color: #855200;
      margin-left: .5rem;
      font-weight: normal;
    }

    img {
      width: .8rem;
      height: .8rem;
      margin-left: .5rem;
      flex: none;
    }
  }

  .center {
    margin: .6rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: .6rem;

    .item {
      width: 3rem;
      text-align: center;

      img {
        width: 2.25rem;
        height: 2.25rem;
        border-radius: .4rem;
      }

      .name {
        font-size: .5rem;
        color: #000;
        text-align: center;
      }
    }
  }

  .close {
    position: absolute;
    bottom: -2.5rem;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    img {
      width: .9rem;
      height: .9rem;
    }
  }
}

// 覆盖Vant默认样式
::v-deep .van-popup {
  background: transparent;
  overflow: inherit;
}
</style>